import User from '@/apiClient/Users'
import Actions from '@/apiClient/Actions'
import i18n from '@/plugins/i18n'
import * as types from './mutationsTypes'
import Company from '@/apiClient/Company'
import Licenses from '@/apiClient/Licenses'
import Payroll from '@/apiClient/Payroll'
import Manager from '@/apiClient/Manager'
import SichernIntegration from '@/apiClient/SichernIntegration'

const user = new User()
const licenses = new Licenses()
const actions = new Actions()
const company = new Company()
const payroll = new Payroll()
const manager = new Manager()
const sichernIntegration = new SichernIntegration()

export default {
  // setSearchRRHH: ({state, commit}, payload) => {
  //     commit('SET_SEARCH_EMPLOYEE_RRHH', payload);
  // }
  setUser: ({ state, commit }, payload) => {
    commit('SET_USER', payload)
  },
  setUsersRelated: ({ state, commit }, payload) => {
    commit('SET_USERS_RELATED', payload)
  },
  setCheckUserEmployee: ({ state, commit }, payload) => {
    commit('SET_CHECK_EMPLOYEE', payload)
  },
  setActions: async ({  commit, state },{ replace = false } = {}) => {
    if (!replace && state.actions.length > 0) { 
      return;
    }
    const response = await actions.getActions()
    commit('SET_ACTIONS', { actions: response.data.results.data })
  },
  setProfile: async ({  commit, state },{ replace = false } = {}) => {
    if (!replace && Object.keys(state.profile).length > 0) { 
      return;
    }
    const response = await user.getprofile()
    commit('SET_PROFILE', { profile: response.data.results.data[0] })
  },
  setConfig: async ({  commit, state },{ replace = false } = {}) => {
    if (!replace && Object.keys(state.config).length > 0) { 
      return;
    }
    const response = await licenses.getConfig()
    commit('SET_CONFIG', { config: response.data.results.data[0] })
  },
  resetConfig:({  commit, state }) => {
    commit('SET_CONFIG', { config: {} })
  },
  setLocale: async ({ commit ,dispatch, state}, payload) => {
    if(payload) {
      i18n.locale = payload.toLowerCase()
      commit('SET_LOCALE', payload.toLowerCase())
    } else {
      await dispatch('setProfile')
      const country = state.profile.pais
      i18n.locale = country.toLowerCase()
      commit('SET_LOCALE', country.toLowerCase())
    }
  },
  setJwt: ({ state, commit }, payload) => {
    commit('SET_JWT', payload)
  },
  setCompanyLoginUrl: ({ state, commit }, payload) => {
    commit('SET_COMPANY_LOGIN_URL', payload)
  },
  clearState: ({ state, commit }, payload) => {
    commit('CLEAR_STATE')
    commit('auth/initialCustomParams')
    commit('documents/CLEAR_ALL_DOCUMENTS_STATE', null, { root: true })
    localStorage.removeItem('vc_remember_later')
  },
  setStateNotOnboarding: ({ state, commit }, payload) => {
    commit('SET_STATE_NOT_ONBOARDING', payload)
  },
  setDocumentsFiltersFolders: ({ state, commit }, payload) => {
    commit('SET_DOCUMENTS_FILTERS_FOLDERS', payload)
  },
  setDocumentsFiltersDate: ({ state, commit }, payload) => {
    commit('SET_DOCUMENTS_FILTERS_DATE', payload)
  },
  setUserDocumentsTotal: ({ state, commit }, payload) => {
    commit('SET_USER_DOCUMENTS_TOTAL', payload)
  },
  setUserFoldersDocuments: ({ state, commit }, payload) => {
    commit('SET_USER_FOLDERS_DOCUMENTS', payload)
  },
  setUnsignedTotalDocsLength: ({ state, commit }, payload) => {
    commit('SET_UNSIGNED_TOTAL_DOCS_LENGTH', payload)
  },
  setAvatarHeader: ({ state, commit }, payload) => {
    commit('SET_AVATAR_HEADER', payload)
  },
  setHasIntegrationSichernPeople: ({ state, commit }, payload) => {
    commit('SET_HAS_INTEGRATION_SICHERN_PEOPLE', payload)
  },
  refreshSichernPeopleIntegration: async ({ commit }) => {
    try {
      const res = await sichernIntegration.checkIntegrationSichernPeople('VP_ABSENCES_HOLIDAYS')
      const enabled = !!(res && res.data && res.data.data && res.data.data.enabled)
      commit('SET_HAS_INTEGRATION_SICHERN_PEOPLE', enabled)
      return enabled
    } catch (error) {
      console.error('Error refreshing Sichern People integration:', error)
      commit('SET_HAS_INTEGRATION_SICHERN_PEOPLE', false)
      return false
    }
  },
  setHasIntegrationSichernConnect: ({ commit }, payload) => {
    commit('SET_HAS_INTEGRATION_SICHERN_CONNECT', payload)
  },

  isManagerRole: ({ state, commit }, payload) => {
    commit('SET_IS_MANAGER_ROLE',payload) 
  },
  clearUserDocuments: ({ state, commit }, payload) => {
    commit('CLEAR_USER_DOCUMENTS')
  },
  clearAvatarImage: ({ state, commit }, payload) => {
    commit('CLEAR_AVATAR_HEADER')
  },
  go_Back_camera_Handler: ({ state, commit }, payload) => {
    commit('GO_BACK_CAMERA_HANDLER', payload)
  },
  // setLoadingStatus: ({state, commit}, payload) => {
  //     commit('SET_LOADING_STATUS', payload)
  // }
  getLogoCompany: ({ commit }, data) => {
        commit(types.SET_LOGO_COMPANY,  user.getCompanyLogo(data))
  },
  getAvatar: async ({ commit }, payload) => {
    await user
      .getAvatarImage(payload.userId)
      .then(response => {
        const avatar = response.data
        commit('SET_AVATAR_HEADER', avatar)
      })
      .catch(e => {
        commit('SET_AVATAR_HEADER', '')
      })
  },
  setChangeUserMail: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      user
        .changeMail(data.pass, data.email)
        .then(response => {
          commit(types.SET_NEW_EMAIL, data.email)
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response.data)
        })
    })
  },
  setChangeUserPass: (_, data) => {
    return new Promise((resolve, reject) => {
      user
        .changePass(data.oldpass, data.pass, data.repass, data.send_mail)
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response.data)
        })
    })
  },
  getProfile: ({ commit }) => {
    return new Promise((resolve, reject) => {
      user
        .getprofile()
        .then(response => resolve(response.data.results.data[0]))
        .catch(e => {
          reject(e.response.data)
        })
    })
  },
  getUserRelated: async ({ commit, state }) => {
    if (state.usersRelated.length > 0) {
      return state.usersRelated
    }
    const response = await user.getUsersRelated()
    return response.data.results.data
  },
  getProfileByIdPatchUserRelated: (_, data) => {
    return new Promise((resolve, reject) => {
      user.getprofileByIdPatchUserRelated(data).then((response) => {
        resolve(response)
      }).catch(e => reject(e.response.data))
    })
  },
  setPrevRouteMfaValidation: ({ state, commit }, payload) => {
    commit('SET_PREVROUTE', payload)
  },
  /*clearStateBeforeError: ({commit}) => {
    commit('CLEAR_STATE')
  }*/
  setAITermsAndConditions: ({commit}, payload) => {
    commit('SET_AI_TERMS_AND_CONDITIONS', payload)
  },
  setLinkUserMergeCandidates: ({commit}, payload) => {
    commit('SET_LINK_USER_MERGE_CANDIDATES', payload)
  },
  setPayrollStatus: async ({commit, state}, { replace = false } = {}) => {
    if (!replace && state.payrollStatus) { 
      return;
    }
    const response = await payroll.getPayrollStatus()
    const isActive = response.data.data.activate_salaryInAdvance;
    commit('SET_PAYROLL_STATUS', isActive)
  },
  clearPayrollStatus: ({commit}) => {
    commit('SET_PAYROLL_STATUS', false)
  },
  setLinkKeycloakResult: ({commit}, payload) => {
    commit('SET_LINK_KEYCLOAK_RESULT', payload)
  },
  clearLinkKeycloakResult: ({commit}) => {
    commit('CLEAR_LINK_KEYCLOAK_RESULT')
  },
  setManagerTasksPending: async ({ commit }) => {
    try {
      const response = await manager.getTotalPendingTasks()
      const totalPending = response.data.data.rows.length || 0
      commit('SET_MANAGER_TASKS_PENDING', totalPending)
    } catch (error) {
      console.error(error)
      commit('SET_MANAGER_TASKS_PENDING', 0)
    }
  }
}
